// extracted by mini-css-extract-plugin
export default {"popup":"popup-y03giy2o","animateFromTop":"animateFromTop-tO1GIrz7"};